const componentStyles = (theme) => ({
  cardRoot: {
    color: theme.palette.white.main,
    backgroundColor: theme.palette.bsColors.MainBlue,
  },
  typographyH2: {
    marginBottom: ".5rem !important",
    color: theme.palette.white.main,
  },
});

export default componentStyles;
